export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const CONVERSATION_STATUS = {
  OPEN: 'open',
  RESOLVED: 'resolved',
  PENDING: 'pending',
  SNOOZED: 'snoozed',
};

export const CONVERSATION_PRIORITY = {
  URGENT: 'urgent',
  HIGH: 'high',
  LOW: 'low',
  MEDIUM: 'medium',
};

export const CONVERSATION_PRIORITY_ORDER = {
  urgent: 4,
  high: 3,
  medium: 2,
  low: 1,
};

export const ALLOWED_FILE_TYPES =
  'image/*,' +
  'audio/*,' +
  'video/*,' +
  '.3gpp,' +
  'text/csv, text/plain, application/json, application/pdf, text/rtf,' +
  'application/xml, text/xml,' +
  'application/zip, application/x-7z-compressed application/vnd.rar application/x-tar,' +
  'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text,' +
  'application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,';

export const CSAT_RATINGS = [
  {
    key: 'disappointed',
    translationKey: 'CSAT.RATINGS.POOR',
    emoji: '😞',
    value: 1,
    color: '#FDAD2A',
  },
  {
    key: 'expressionless',
    translationKey: 'CSAT.RATINGS.FAIR',
    emoji: '😑',
    value: 2,
    color: '#FFC532',
  },
  {
    key: 'neutral',
    translationKey: 'CSAT.RATINGS.AVERAGE',
    emoji: '😐',
    value: 3,
    color: '#FCEC56',
  },
  {
    key: 'grinning',
    translationKey: 'CSAT.RATINGS.GOOD',
    emoji: '😀',
    value: 4,
    color: '#6FD86F',
  },
  {
    key: 'smiling',
    emoji: '😍',
    translationKey: 'CSAT.RATINGS.EXCELLENT',
    value: 5,
    color: '#44CE4B',
  },
];

export const CSAT_DISPLAY_TYPES = {
  EMOJI: 'emoji',
  STAR: 'star',
};

export const AUDIO_FORMATS = {
  WEBM: 'audio/webm',
  OGG: 'audio/ogg',
  MP3: 'audio/mp3',
  WAV: 'audio/wav',
};

// `i18nKey` aponta para CONVERSATION.MESSAGE_VARIABLES.* — e o que aparece na
// lista de variaveis do compositor. O `label` permanece em ingles de proposito:
// e por ele que a busca por variavel casa, e ele nao e exibido.
export const MESSAGE_VARIABLES = [
  {
    label: 'Conversation Id',
    i18nKey: 'CONVERSATION_ID',
    key: 'conversation.id',
  },
  {
    label: 'Contact Id',
    i18nKey: 'CONTACT_ID',
    key: 'contact.id',
  },
  {
    label: 'Contact name',
    i18nKey: 'CONTACT_NAME',
    key: 'contact.name',
  },
  {
    label: 'Contact first name',
    i18nKey: 'CONTACT_FIRST_NAME',
    key: 'contact.first_name',
  },
  {
    label: 'Contact last name',
    i18nKey: 'CONTACT_LAST_NAME',
    key: 'contact.last_name',
  },
  {
    label: 'Contact email',
    i18nKey: 'CONTACT_EMAIL',
    key: 'contact.email',
  },
  {
    label: 'Contact phone',
    i18nKey: 'CONTACT_PHONE',
    key: 'contact.phone',
  },
  {
    label: 'Agent name',
    i18nKey: 'AGENT_NAME',
    key: 'agent.name',
  },
  {
    label: 'Agent first name',
    i18nKey: 'AGENT_FIRST_NAME',
    key: 'agent.first_name',
  },
  {
    label: 'Agent last name',
    i18nKey: 'AGENT_LAST_NAME',
    key: 'agent.last_name',
  },
  {
    label: 'Agent email',
    i18nKey: 'AGENT_EMAIL',
    key: 'agent.email',
  },
  {
    key: 'inbox.name',
    i18nKey: 'INBOX_NAME',
    label: 'Inbox name',
  },
  {
    label: 'Inbox id',
    i18nKey: 'INBOX_ID',
    key: 'inbox.id',
  },
];

export const ATTACHMENT_ICONS = {
  image: 'image',
  audio: 'headphones-sound-wave',
  video: 'video',
  // Aceleres: o GIF usa o icone do video de proposito — nao existe um icone de
  // GIF neste conjunto, e sem entrada aqui a previa da lista ficaria sem icone.
  // O que muda e o texto ao lado ("GIF", nao "Mensagem de video").
  gif: 'video',
  file: 'document',
  location: 'location',
  fallback: 'link',
  // Aceleres: cartao de contato compartilhado. Sem entrada aqui a previa da
  // lista de conversas fica sem icone ao lado de "Contato compartilhado".
  contact: 'person',
};

export const TWILIO_CONTENT_TEMPLATE_TYPES = {
  TEXT: 'text',
  MEDIA: 'media',
  QUICK_REPLY: 'quick_reply',
  CALL_TO_ACTION: 'call_to_action',
};
